import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Button,
  Grid,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import {createAdditionalSkusApi, editAdditionalSkusApi} from 'api/subscription';


const SkusForm = ({sku, setSku}) => {
  const dispatch = useDispatch();
  const {additionalSkus} = useSelector((state) => state.subscription);
  const additionalSkusSortOrders = additionalSkus.reduce((orders, el) => {
    if (el.order !== sku?.order) {
      return [...orders, el.order];
    }

    return orders;
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          _id: sku?._id || '',
          skuValue: sku?.value || '',
          order: sku?.order || 0,
          price: sku?.price || '',
          isOneTime: sku?.isOneTime || false
        }}
        onSubmit={async (values) => {
          const sku = {
            value: values.skuValue,
            order: values.order,
            price: values.price,
            isOneTime: values.isOneTime
          };

          if (values._id) {
            await editAdditionalSkusApi({dispatch, skuId: values._id, sku});
          } else {
            await createAdditionalSkusApi({dispatch, sku});
          }

          setSku(null);
        }}
        validationSchema={
          yup.object({
            skuValue: yup
              .number()
              .typeError('Sku value must be a number')
              .required('Field is required')
              .min(0, 'Value cannot go lower than 0'),
            order: yup
              .number()
              .notOneOf(additionalSkusSortOrders, 'Sort order already specified')
              .min(0, 'Value cannot go lower than 0')
              .typeError('Order value must be a number')
              .required('Field is required'),
            price: yup
              .number()
              .typeError('Price value must be a number')
              .required('Field is required')
              .min(0, 'Value cannot go lower than 0'),
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => (
          <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
            <Grid container spacing={3} className="p-4">
              <Grid item xs={12} sm={12} md={12}>
                <FormControl>
                  <RadioGroup
                    name="isOneTime"
                    value={values.isOneTime ? '1' : '0'}
                    onChange={({target: {value}}) => setFieldValue('isOneTime', value === '1')}
                    row
                  >
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      label="One Time Price"
                      value="1"
                    />

                    <FormControlLabel
                      control={<Radio color="primary" />}
                      label="Monthly Subscription Price"
                      value="0"
                    />
                  </RadioGroup>
                </FormControl>
                <TextField
                  required
                  className="w-full mt-10"
                  label="Price"
                  name="price"
                  variant="outlined"
                  value={values.price}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.price && Boolean(errors.price)}
                  helperText={touched.price && errors.price}
                />
                <TextField
                  required
                  className="w-full mt-5"
                  label="Value"
                  name="skuValue"
                  variant="outlined"
                  value={values.skuValue}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.skuValue && Boolean(errors.skuValue)}
                  helperText={touched.skuValue && errors.skuValue}
                />
                <TextField
                  required
                  className="w-full mt-5"
                  label="Order"
                  name="order"
                  variant="outlined"
                  value={values.order}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.order && Boolean(errors.order)}
                  helperText={touched.order && errors.order}
                />
                <div className="flex items-center justify-end mt-8">
                  <Button
                    variant="contained"
                    onClick={() => setSku(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-10"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default SkusForm;
